// Warm the landing-screen code chunk while the POST /auth round-trip is still
// in flight.
//
// The screen chunks are served from the Cloudflare edge CDN (fast), but App.tsx
// only requests them *after* auth resolves — needlessly serializing a quick CDN
// fetch behind a slower Railway round-trip. Kicking the dynamic import() off at
// boot (manager) / the moment auth resolves (director) means the chunk is
// usually already parsed by the time the authed tree commits, removing a
// round-trip from first paint.
//
// import() is module-cache deduped, so calling these alongside App.tsx's own
// lazy() for the same path is a no-op the second time — they resolve to the
// exact same chunk. .catch(() => {}) swallows a stale-hash failure here; the
// real lazy() in App.tsx owns the reload-on-stale recovery.

/** Manager "Сегодня" — the default landing for the common case. */
export function prefetchManagerLanding(): void {
  void import('../screens/TodayScreen').catch(() => {})
}

/** Director dashboard (pulls the grouped "director" chunk — director-only). */
export function prefetchDirectorLanding(): void {
  void import('../screens/director/DashboardScreen').catch(() => {})
}
